








import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
// import { State } from 'vuex-class'


import { getDigitalCurrencyAmountWithCommaSeparatedValue } from '../basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-2-get-digital-currency-amount-with-comma-separated-value'

import { getNumberWithFixedDecmial1 } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-1-algorithms/algorithms-type-9-get-number-with-fixed-decimal/get-number-with-fixed-decimal-1'

@Component({
  components: {}
})
class UserInterface7LargeNumberDisplay extends Vue {
  @Prop({ default: 0 }) numberValue?: number
  @Prop({ default: 6 }) maximumNumberOfUnitPlaces?: number
  @Prop({ default: 2 }) maximumNumberOfDecimalPlaces?: number
  @Prop({ default: false }) useENotation?: boolean

  getDigitalCurrencyAmountWithCommaSeparatedValue = getDigitalCurrencyAmountWithCommaSeparatedValue

  get showExponentialFormForLargeNumber (): boolean {
    const isMaximumNumberOfUnitPlacesReached = this.getNumberOfUnitPlaces(this.numberValue!) > this.maximumNumberOfUnitPlaces!
    return isMaximumNumberOfUnitPlacesReached
  }

  get showExponentialFormForSmallNumber (): boolean {
    const isUnitPlaceEqualToZero = Math.floor(Math.abs(this.numberValue!)) === 0
    const isMaximumNumberOfDecimalPlacesReached = this.getNumberOfDecimalPlaces(this.numberValue!) > this.maximumNumberOfDecimalPlaces!
    return isUnitPlaceEqualToZero && isMaximumNumberOfDecimalPlacesReached
  }

  get isNumberExpressedAsFullNumber () {
    return !this.showExponentialFormForLargeNumber && !this.showExponentialFormForSmallNumber
  }

  get getExponentialFormData () {
    let leadingNumber = ''
    let exponentialNumber = 0
    const numberSplitByDecimalPoint = getNumberWithFixedDecmial1(this.numberValue!).toString().split('.')

    if (this.showExponentialFormForLargeNumber) {
      const numberValue = `${getNumberWithFixedDecmial1(parseFloat(numberSplitByDecimalPoint[0]))}`
      leadingNumber = [numberValue.slice(0, 1), '.', numberValue.slice(1, 1 + this.maximumNumberOfDecimalPlaces!)].join('')
      exponentialNumber = numberValue.length - 1
    } else if (this.showExponentialFormForSmallNumber) {
      const numberValue = `${getNumberWithFixedDecmial1(parseFloat(numberSplitByDecimalPoint[1]))}`
      leadingNumber = [numberValue.slice(0, 1), '.', numberValue.slice(1, 1 + this.maximumNumberOfDecimalPlaces!)].join('')
      exponentialNumber = -(numberSplitByDecimalPoint[1].indexOf(numberValue) + 1)
    }

    return {
      leadingNumber,
      exponentialNumber
    }
  }

  getNumberOfUnitPlaces (numberValue: number) {
    let numberOfUnitPlaces = 0
    let remainingNumber = numberValue

    while (remainingNumber > 0) {
      remainingNumber /= 10
      remainingNumber = Math.floor(remainingNumber)
      numberOfUnitPlaces++
    }

    return numberOfUnitPlaces
  }

  getNumberOfDecimalPlaces (numberValue: number) {
    const doesNumberHaveDecimalPlace = numberValue % 1 !== 0
    if (!doesNumberHaveDecimalPlace) {
      return 0
    }

    const numberOfDecimalPlaces = getNumberWithFixedDecmial1(numberValue % 1).toString().split('.')[1].length

    return numberOfDecimalPlaces
  }

}

export default UserInterface7LargeNumberDisplay

